







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ModalPlugin } from "bootstrap-vue";
import {
  BCard,
  BCarousel,
  BCarouselSlide,
  BRow,
  BCol,
  BCardText,
  BCardImg,
  BButton,
  BModal,
  VBModal,
  directivesPlugin,
} from "bootstrap-vue";
Vue.use(ModalPlugin);

@Component({
  components: {
    BCard,
    BCarousel,
    BCarouselSlide,
    BRow,
    BCol,
    BCardText,
    BCardImg,
    BButton,
    BModal,
  },
})
export default class InPractisePerfPhone extends Vue {}
